export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const SPACE = ' ';
export const ESCAPE = 'Escape';
export const ENTER = 'Enter';
export const TAB = 'Tab';
export const BACKSPACE = 'Backspace';
